<template>
  <div class="x_panel" v-if="isOpen">
    <div class="x_title">
      <slot name="title">
        <h2>{{ title }} <small v-if="subTittle">{{ subTittle }}</small></h2>
        <ul class="nav navbar-right panel_toolbox">
          <slot name="btn"></slot>
          <li v-if="showCollapse">
            <a class="collapse-link" @click="toggleCollapse"><i class="fa fa-chevron-up" ref="icon"></i></a>
          </li>
          <li class="dropdown" v-if="showDropdown">
            <a aria-expanded="false"
               class="dropdown-toggle"
               data-toggle="dropdown" href="javascript:" role="button">
              <i class="fa fa-wrench"></i>
            </a>
            <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
              <slot name="dropdownItem">
              </slot>
            </div>
          </li>
          <li v-if="showClose">
            <a class="close-link" @click="close"><i class="fas fa-times"></i></a>
          </li>
        </ul>
      </slot>
      <div class="clearfix"></div>
    </div>
    <div class="x_content" ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: {
    title: String,
    subTittle: String,
    showDropdown: Boolean,
    showClose: Boolean,
    showCollapse: Boolean,
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      is_open: true,
    }
  },
  methods: {
    toggleCollapse() {
      var $BOX_PANEL = $(this.$el),
          $ICON = $(this.$refs.icon),
          $BOX_CONTENT = $(this.$refs.content);

      // fix for some div with hardcoded fix class
      if ($BOX_PANEL.attr('style')) {
        $BOX_CONTENT.slideToggle(200, function () {
          $BOX_PANEL.removeAttr('style');
        });
      } else {
        $BOX_CONTENT.slideToggle(200);
        $BOX_PANEL.css('height', 'auto');
      }

      $ICON.toggleClass('fa-chevron-up fa-chevron-down');
    },
    close() {
      this.$emit("close");
      this.$emit("update:isOpen", false);
      this.is_open = false;
    },
    open() {
      this.$emit("open");
      this.$emit("update:isOpen", true);
      this.is_open = true;
    }
  }
}
</script>

<style scoped>

</style>